document.addEventListener('DOMContentLoaded', () => {
    const COOKIE_NAME = 'cookie_consent';
    const COOKIE_MAX_AGE = 365 * 24 * 60 * 60;
    const banner = document.querySelector('[data-cookie-notice]');

    if (!banner || banner.getAttribute('data-cookie-notice-inited') === '1') {
        return;
    }

    const getCookie = (name) => {
        const matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : '';
    };

    if (getCookie(COOKIE_NAME) === '1') {
        banner.remove();
        return;
    }

    banner.setAttribute('data-cookie-notice-inited', '1');

    const closeBtn = banner.querySelector('[data-cookie-notice-close]');
    if (!closeBtn) {
        return;
    }

    closeBtn.addEventListener('click', () => {
        let cookie = encodeURIComponent(COOKIE_NAME) + '=1; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
        if (location.protocol === 'https:') {
            cookie += '; Secure';
        }
        document.cookie = cookie;
        banner.remove();
    });
});
